<template>
    <div id="counsellor-add">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#counsellorAdd"
            @click="resetForm()"><i class="fas fa-plus"></i> Add</button>

        <!-- Modal -->
        <div class="modal fade text-left" id="counsellorAdd" tabindex="-1" aria-labelledby="counsellorAddLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="counsellorAddLabel">Add Counsellor <i v-if="loading"
                                class="fas fa-spinner fa-spin"></i></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="alert.status" :class="getAlertClass()" role="alert">
                            <i :class="getAlertIcon()"></i> {{ alert.message }}
                        </div>
                        <form id="counsellor-add-form" @submit.prevent>
                            <div class="form-group">
                                <label for="searchTerm">Search Term </label><small
                                    class="ml-1 font-weight-bold text-danger">*Required</small>
                                <input type="text" class="form-control form-control-sm" id="searchTerm"
                                    name="searchTerm" v-model="searchTerm" aria-describedby="searchTerm"
                                    placeholder="Please provide a search term" @keydown.enter="search()">
                            </div>
                            <div class="form-group">
                                <label for="searchType">Type</label><small
                                    class="ml-1 font-weight-bold text-danger">*Required</small>
                                <select class="form-control form-control-sm" id="searchType" name="searchType"
                                    v-model="searchType">
                                    <option value="department">Department</option>
                                    <option value="people">People</option>
                                </select>
                            </div>
                        </form>
                        <div class="text-right">
                            <button v-if="searchLoad" type="button" class="btn btn-sm btn-success mr-2" disabled>Search
                                <i class="fas fa-spinner fa-spin"></i></button>
                            <button v-else type="button" class="btn btn-sm btn-success mr-2"
                                @click="search()">Search</button>
                            <button type="button" class="btn btn-sm btn-warning" @click="resetForm()">Reset</button>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Department</th>
                                            <th scope="col">Mail</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in searchItems" :key="i">
                                            <td>{{ item.cn || "N/A" }}</td>
                                            <td>{{ item.department || "N/A" }}</td>
                                            <td>{{ item.mail || "N/A" }}</td>
                                            <td>
                                                <button v-if="loading" type="button" class="btn btn-sm btn-success"
                                                    disabled><i class="fas fa-spinner fa-spin"></i></button>
                                                <button v-else type="button" class="btn btn-sm btn-success"
                                                    @click="addCounsellor(item)"><i class="fas fa-user-plus"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="searchItems.length == 0" class="alert alert-primary my-3" role="alert">
                                    <i class="fas fa-bell"></i> There are currently no search items. Please use the
                                    form to search for user(s).
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'counsellors-add',
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            loading: false,
            searchLoad: false,
            searchItems: [],
            searchTerm: '',
            searchType: 'people'
        }
    },
    methods: {
        addCounsellor(item) {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?setCounsellorsData`;
            const formData = new FormData();

            // Set loading
            this.alert.status = false;
            this.loading = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                commonName: `${item.sn}, ${item.givenName}`,
                // givenName: item.givenName,
                office: '',
                role: item.title,
                // surname: item.sn,
                username: item.sAMAccountName,
                waitingArea: '',
                zoomLink: ''
            }));
            formData.append('mode', 'setCounsellorsData');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alert.message = `${item.cn} has been successfully been added as a counsellor.`;
                    that.alert.type = "success";

                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alert.message = `${item.cn} could not be added as a counsellor. ${json.message}`;
                    that.alert.type = "warning";
                } else {
                    // Internal error
                    that.alert.message = `${item.cn} could not be added as a counsellor. An error has occurred. Please contact your system administrator.`;
                    that.alert.type = "danger";
                }

                that.refreshData();
                that.alert.status = true;
                that.loading = false;
            }).catch(function () {
                // Internal error
                that.alert.message = `${item.cn} could not be added as a counsellor. An error has occurred. Please contact your system administrator.`;
                that.alert.type = "danger";
                that.alert.status = true;
                that.loading = false;
            })
        },
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.alert = {
                message: '',
                status: false,
                type: ''
            };
            this.searchItems = [];
            this.searchTerm = '';
            this.searchType = 'people';
        },
        search() {
            const that = this;
            let api = `https://${location.hostname}/cgi-bin/mkvn/controller.api.kdap.pl?search&type=${this.searchType}&term=${this.searchTerm}&bypassFilters=removetestaccounts`;

            // Set loading
            this.alert.status = false;
            this.searchLoad = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.Warning) {
                        if (json.Warning.match(/^Please supply/i)) {
                            that.alert.message = `Please provide a search term with atleast 2 characters.`;
                            that.alert.status = `warning`;
                        } else {
                            that.alert.message = `Search found 0 matching record(s) using the term "${that.searchTerm}".`;
                            that.alert.status = `primary`;
                        }

                        that.searchItems = [];
                    } else {
                        that.searchItems = json;
                        that.alert.message = `Search found ${json.length} matching record(s) using the term "${that.searchTerm}".`;
                        that.alert.status = `success`;
                    }

                    that.alert.status = true;
                    that.searchLoad = false;
                })
                .catch(function () {
                    that.alert.status = true;
                    that.searchLoad = false;
                    that.alert.message = `An error occurred. Please contact your system administrator.`;
                    that.alert.status = `danger`;
                })
        }
    }
}
</script>